import { render, staticRenderFns } from "./edc-form-source-documents.vue?vue&type=template&id=44ad0866&scoped=true&"
import script from "./edc-form-source-documents.vue?vue&type=script&lang=js&"
export * from "./edc-form-source-documents.vue?vue&type=script&lang=js&"
import style0 from "./edc-form-source-documents.vue?vue&type=style&index=0&id=44ad0866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ad0866",
  null
  
)

component.options.__file = "edc-form-source-documents.vue"
export default component.exports